// Mirror of legacy frontend/src/utils/utility.js:135-138 htmlDecode.
// Duplicated locally because pantry-features cannot import from the
// main app's ~/utils tree. Used by the Category drawer to render
// HTML-encoded headlines / descriptions returned by the backend.

export const htmlDecode = (input: string): string | null => {
  if (!input) return ''
  const doc = new DOMParser().parseFromString(input, 'text/html')
  return doc.documentElement.textContent
}
